/**
 * Le parseur du message d'un run ETL (`adm.SyncLogs.message`), lu par SyncStatusPanel.
 *
 * Module a part du composant : un `.tsx` qui exporte autre chose qu'un composant rougit
 * `react-refresh/only-export-components` (lint a zero avertissement), et le parseur doit
 * etre exporte pour que son temoin le juge (ADR-075 D3, lot test-l-etl-ne-contourne-plus-le-dag).
 *
 * La forme lue est celle qu'ecrit `finalizeSyncLog` (@gs/etl, syncLogging.ts) :
 * `<cible>: <n> rows`, `<cible>: error (<cause>)`, `<cible>: skipped (<cause>)`, separes par ` | `.
 */

export interface ParsedStep {
  name: string;
  rows: number | null;
  status: 'done' | 'error' | 'skipped' | 'pending' | 'running';
  errorMsg?: string;
}

/**
 * Le `skipped` est reconnu EXPLICITEMENT (ADR-075). Sans cette branche, une étape
 * sautée retombait dans le cas par défaut « done » — le statut neuf aurait été
 * absorbé en vert par un lecteur existant, c'est-à-dire exactement le mensonge que
 * le statut existe pour supprimer.
 */
export function parseMessage(message: string): ParsedStep[] {
  return message.split(' | ').map((part) => {
    const colonIdx = part.indexOf(':');
    if (colonIdx === -1) return { name: part, rows: null, status: 'done' };
    const name = part.slice(0, colonIdx).trim();
    const rest = part.slice(colonIdx + 1).trim();
    if (rest.startsWith('error')) {
      const errMatch = rest.match(/error \((.+)\)/);
      return { name, rows: null, status: 'error', errorMsg: errMatch?.[1] ?? rest };
    }
    if (rest.startsWith('skipped')) {
      const skipMatch = rest.match(/skipped \((.+)\)/);
      return { name, rows: null, status: 'skipped', errorMsg: skipMatch?.[1] ?? rest };
    }
    const rowMatch = rest.match(/(\d+) rows/);
    return { name, rows: rowMatch ? parseInt(rowMatch[1], 10) : null, status: 'done' };
  });
}
